import { type FC } from "react";

import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";

import { Button } from "@styled/button";

import { GuidedBubble } from "./guided_bubble";
import { NewProjectFields, useNewProjectForm } from "./new_project_form";

// The permanently-selected strip and the real New Case form beneath it. Shared
// by the first-run empty state and the no-results state; `tag` is the amber
// "Start here", which only the first run earns.
export const NewCaseInline: FC<{ tag?: string }> = ({ tag }) => {
  const form = useNewProjectForm();

  return (
    <>
      <div className="mt-4 w-full">
        <GuidedBubble
          interactive={false}
          selected
          density="sm"
          mark={{ icon: faPlus }}
          label="Create a case"
          tag={tag}
          body="Name and assign"
        />
      </div>

      <form
        onSubmit={form.onSubmit}
        className="mt-3 w-full rounded-xl border border-indigo-300 bg-white p-4"
      >
        <div className="mb-3 text-[13.5px] font-bold text-slate-900">
          New Case
        </div>

        <NewProjectFields form={form} />

        <div className="mt-4 flex justify-end">
          <Button type="submit" color="indigo" size="sm" loading={form.loading}>
            Create case
          </Button>
        </div>
      </form>
    </>
  );
};
